"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const CloseButton_1 = __importDefault(require("~/components/common/controls/CloseButton"));
const ErrorModals_1 = require("~/components/ErrorModals");
const EmailsInput_1 = __importDefault(require("~/components/UI/EmailsInput"));
const consts_1 = require("~/store/account/consts");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const react_helmet_async_1 = require("react-helmet-async");
const ChangeCredentials_1 = require("../../ChangeCredentials/ChangeCredentials");
const InviteTeamMember_module_scss_1 = __importDefault(require("./InviteTeamMember.module.scss"));
function InviteTeamMember() {
    const { t } = (0, react_i18next_1.useTranslation)('account');
    const distributorId = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUserDistributorId);
    const errors = (0, react_redux_1.useSelector)(selectors_1.selectResponseError);
    const userType = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUserRole);
    const [isSubmitted, setIsSubmitted] = (0, react_1.useState)(false);
    const [disableSubmit, setDisableSubmit] = (0, react_1.useState)(false);
    const { dispatchInviteTeamMember, dispatchEditResponseErrors } = (0, redux_1.bindActionCreators)({ dispatchInviteTeamMember: actions_1.inviteTeamMember, dispatchEditResponseErrors: actions_1.responseErrors }, (0, react_redux_1.useDispatch)());
    const navigate = (0, react_router_dom_1.useNavigate)();
    const sentInvitations = (emails) => {
        if (distributorId) {
            dispatchInviteTeamMember({ emails, distributorId, navigateBack: () => navigate(-1) });
        }
        setIsSubmitted(false);
        setDisableSubmit(true);
    };
    if (userType === consts_1.UserRoles.customer) {
        return react_1.default.createElement(ErrorModals_1.ForbiddenModal, null);
    }
    return (react_1.default.createElement("div", { className: InviteTeamMember_module_scss_1.default.overlay },
        react_1.default.createElement(react_helmet_async_1.Helmet, null,
            react_1.default.createElement("title", null, "Invite Team Members | TBUILD")),
        react_1.default.createElement("div", { className: InviteTeamMember_module_scss_1.default.window },
            react_1.default.createElement("div", { className: InviteTeamMember_module_scss_1.default.modal },
                react_1.default.createElement("div", { className: InviteTeamMember_module_scss_1.default.headline },
                    react_1.default.createElement("span", null, "Invite Member"),
                    react_1.default.createElement("div", { className: InviteTeamMember_module_scss_1.default.controls },
                        (0, ChangeCredentials_1.profileButtons)(() => {
                            navigate(-1);
                            dispatchEditResponseErrors([]);
                        }, () => setIsSubmitted(true), disableSubmit, t),
                        react_1.default.createElement(CloseButton_1.default, { onCLickHandler: () => navigate(-1) }))),
                react_1.default.createElement("div", { className: InviteTeamMember_module_scss_1.default.body },
                    react_1.default.createElement(EmailsInput_1.default, { isSubmitted: isSubmitted, submitHandler: sentInvitations, disableSubmit: (state) => setDisableSubmit(state), errors: errors, editErrors: (value) => dispatchEditResponseErrors(value) }),
                    errors ? (react_1.default.createElement("div", { className: InviteTeamMember_module_scss_1.default.errors }, errors.map((error) => {
                        const key = Object.keys(error)[0];
                        return (react_1.default.createElement("div", { key: key, className: InviteTeamMember_module_scss_1.default.error }, error[key]));
                    }))) : null)))));
}
exports.default = InviteTeamMember;
